<script lang="ts" setup>
const props = defineProps({
  color: {
    type: String,
    default: "primary",
  },
  showSpinner: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  autoFocus: {
    type: Boolean,
    default: false,
  },
  dataStepId: {
    type: String,
  },
  size: {
    type: String as PropType<"sm" | "md">,
    default: "md",
  },
  type: {
    type: String as PropType<"button" | "submit" | "reset">,
    required: false,
  },
});

const emits = defineEmits(["click"]);

const dynamicStyles: any = {};

switch (props.color) {
  case "secondary":
    dynamicStyles[
      `bg-secondary-default hover:bg-secondary-shade text-secondary-on`
    ] = true;
    break;
  case "medium": // Medium is the default color
    dynamicStyles[`bg-medium-default hover:bg-medium-tint text-medium-on`] =
      true;
    break;
  case "google":
    dynamicStyles[`bg-google-default hover:bg-google-shade text-google-on`] =
      true;
    break;
  case "danger":
    dynamicStyles[`bg-danger-default hover:bg-danger-shade text-danger-on`] =
      true;
    break;
  case "warning":
    dynamicStyles[`bg-warning-default hover:bg-warning-shade text-warning-on`] =
      true;
    break;
  case "success":
    dynamicStyles[`bg-success-default hover:bg-success-shade text-success-on`] =
      true;
    break;
  case "primary":
  default:
    dynamicStyles[`bg-primary-default hover:bg-primary-shade text-primary-on`] =
      true;
    break;
}

const onClick = () => {
  if (props.disabled) return;

  emits("click");
};

const buttonRef = ref();
onMounted(() => {
  if (props.autoFocus) {
    buttonRef.value?.focus();
  }
});
</script>

<template>
  <div class="relative rounded cursor-pointer">
    <button
      ref="buttonRef"
      class="w-full rounded select-none h-full flex flex-col items-center justify-center"
      :type="type"
      :data-step-id="dataStepId"
      :class="{
        ...dynamicStyles,
        '!text-medium-tint !bg-light-default cursor-not-allowed ': disabled,
        ' !active:bg-opacity-20': disabled != true,
        'text-body-2 p-1': size == 'sm',
        'px-4 py-2 text-input-1 ': size == 'md',
      }"
      @click="onClick"
    >
      <slot />
    </button>
    <transition>
      <div
        v-if="showSpinner"
        class="flex rounded items-center justify-center absolute top-0 left-0 w-full h-full bg-overlay"
      >
        <icon name="svg-spinners:ring-resize" class="text-white" size="20" />
      </div>
    </transition>
  </div>
</template>

<style scoped>
.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 150ms ease-in;
}

.v-enter-to,
.v-leave-from {
  opacity: 1;
}
</style>
